import {
  joiValidator,
  joiActiveRevisionRef,
  joiDecimal,
} from "@/shared/validators";
import { Ingredient } from "@megarax/client/src/resources/plm/Ingredient";

export const ingredientValidator = joiValidator<Ingredient>({
  komponent: joiActiveRevisionRef,
  massKg: joiDecimal,
});
